// import React, { useState, useEffect } from "react";
// import { Header } from "../../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import "./gtcustomer.css";
// import { local_signage, local_url } from "../../Const";

// const formatDateForInput = (date) => {
//   const d = new Date(date);
//   const year = d.getFullYear();
//   const month = String(d.getMonth() + 1).padStart(2, "0");
//   const day = String(d.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// };

// const formatDateForAPI = (date) => {
//   if (typeof date === 'string' && date.includes('-')) {
//     return date.replace(/-/g, "");
//   }
//   // For dayjs objects
//   const d = dayjs(date);
//   return d.format('YYYYMMDD');
// };

// const formatDateTime = (dateTime, formatType) => {
//   if (!dateTime || dateTime === "1753-01-01T00:00:00") return "-";
//   const date = new Date(dateTime);
//   if (formatType === "date") {
//     return `${String(date.getDate()).padStart(2, "0")}-${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}-${date.getFullYear()}`;
//   }
//   if (formatType === "time") {
//     return `${String(date.getHours()).padStart(2, "0")}:${String(
//       date.getMinutes()
//     ).padStart(2, "0")}`;
//   }
//   return "-";
// };

// export const GTOrderMove = () => {
//   const today = new Date();
//   const sixtyDaysAgo = new Date(today);
//   sixtyDaysAgo.setDate(today.getDate() - 1);
//   const [sfAreas, setSfAreas] = useState([{ SFAreaId: "ALL", SFAreaName: "ALL" }]);
//   const [selectedSFAreaId, setSelectedSFAreaId] = useState("ALL");
//   const userId = localStorage.getItem("userId");

//   // New states for business segments and verticals
//   const [businessSegments, setBusinessSegments] = useState([]);
//   const [businessVerticals, setBusinessVerticals] = useState([{ businessVerticalCode: "ALL", businessVerticalName: "ALL" }]);
//   const [selectedSegment, setSelectedSegment] = useState("MODERN"); // Default to MODERN
//   const [selectedVertical, setSelectedVertical] = useState("ALL");

//   const [ledgerData, setLedgerData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [fromDate, setFromDate] = useState(dayjs(sixtyDaysAgo));
//   const [toDate, setToDate] = useState(dayjs(today));
//   const [searchQuery, setSearchQuery] = useState("");
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: 'ascending'
//   });

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [recordsPerPage] = useState(100);

//   const datePickerStyle = {
//     width: 170,
//     margin: "0 8px"
//   };

//   const calculateDateLimits = (startDate) => {
//     const start = dayjs(startDate);
//     let maxDate = start.add(2, 'month');

//     if (maxDate.isAfter(dayjs())) {
//       maxDate = dayjs();
//     }

//     return {
//       maxDate
//     };
//   };

//   const handleFromDateChange = (newValue) => {
//     setFromDate(newValue);

//     const maxAllowedDate = dayjs(newValue).add(2, 'month');
//     if (dayjs(toDate).isAfter(maxAllowedDate)) {
//       setToDate(maxAllowedDate);
//     }
//   };

//   const handleToDateChange = (newValue) => {
//     setToDate(newValue);
//   };

//   const handleSort = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Fetch business segments
//   const fetchBusinessSegments = async () => {
//     try {
//       const token = localStorage.getItem('AuthorizationToken');
  
//       const response = await fetch(`${local_url}/api/BizSegments`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });
  
//       if (!response.ok) throw new Error("Failed to fetch Business Segments");
  
//       const data = await response.json();
      
//       // Add ALL option to the business segments
//       const segmentsWithAll = [
//         { businessSegmentCode: "ALL", businessSegmentName: "ALL", deleted: "N" },
//         ...data
//       ];
      
//       setBusinessSegments(segmentsWithAll);
//     } catch (error) {
//       setError("Failed to fetch Business Segments. Please try again later.");
//     }
//   };
  
//   // Fetch business verticals based on selected segment
//   const fetchBusinessVerticals = async (segment) => {
//     if (!segment || segment === "ALL") {
//       setBusinessVerticals([{ businessVerticalCode: "ALL", businessVerticalName: "ALL" }]);
//       return;
//     }
  
//     try {
//       const token = localStorage.getItem('AuthorizationToken');
  
//       const response = await fetch(`${local_url}/api/BizVertical/${segment}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });
  
//       if (!response.ok) throw new Error("Failed to fetch Business Verticals");
  
//       const data = await response.json();
      
//       // Add ALL option to the business verticals
//       const verticalsWithAll = [
//         { businessVerticalCode: "ALL", businessVerticalName: "ALL" },
//         ...data
//       ];
      
//       setBusinessVerticals(verticalsWithAll);
      
//       // Reset selected vertical to ALL when segment changes
//       setSelectedVertical("ALL");
//     } catch (error) {
//       setError("Failed to fetch Business Verticals. Please try again later.");
//       setBusinessVerticals([{ businessVerticalCode: "ALL", businessVerticalName: "ALL" }]);
//     }
//   };

//   const fetchSfAreas = async () => {
//     try {
//       if (!selectedSegment || selectedSegment === "ALL") {
//         // If no segment is selected or ALL is selected, set an empty array with just the ALL option
//         setSfAreas([{ SFAreaId: "ALL", SFAreaName: "ALL" }]);
//         return;
//       }

//       const token = localStorage.getItem('AuthorizationToken');

//       const response = await fetch(`${local_signage}/api/v1/sfareabysegment?SegmentCode=${selectedSegment}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });
      
//       if (!response.ok) throw new Error("Failed to fetch SF Areas");
//       const data = await response.json();

//       // Add ALL option to the SF Areas
//       const areasWithAll = [
//         { SFAreaId: "ALL", SFAreaName: "ALL" },
//         ...data
//       ];
      
//       setSfAreas(areasWithAll);
//       // Reset selected SF Area to ALL when segment changes
//       setSelectedSFAreaId("ALL");
//     } catch (error) {
//       setError("Failed to fetch SF Areas. Please try again later.");
//       // Even on error, set the ALL option
//       setSfAreas([{ SFAreaId: "ALL", SFAreaName: "ALL" }]);
//     }
//   };

//   useEffect(() => {
//     // Only fetch business segments on component mount
//     fetchBusinessSegments();
//   }, []);

//   // Fetch business verticals when selected segment changes
//   useEffect(() => {
//     fetchBusinessVerticals(selectedSegment);
//     fetchSfAreas(); // Also fetch SF Areas when segment changes
//   }, [selectedSegment]);

//   // Reset to first page when data changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filteredData]);

//   const getSortedData = (data) => {
//     if (!sortConfig.key) return data;

//     return [...data].sort((a, b) => {
//       let aValue = a[sortConfig.key];
//       let bValue = b[sortConfig.key];

//       // Handle numeric values
//       if (typeof aValue === 'number' && typeof bValue === 'number') {
//         return sortConfig.direction === 'ascending'
//           ? aValue - bValue
//           : bValue - aValue;
//       }

//       // Handle date values
//       if (sortConfig.key.includes('DateTime')) {
//         aValue = aValue ? new Date(aValue) : new Date(0);
//         bValue = bValue ? new Date(bValue) : new Date(0);
//         return sortConfig.direction === 'ascending'
//           ? aValue - bValue
//           : bValue - aValue;
//       }

//       // Handle string values
//       aValue = (aValue || '').toString().toLowerCase();
//       bValue = (bValue || '').toString().toLowerCase();

//       if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
//       if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
//       return 0;
//     });
//   };

//   const SortIcon = ({ columnKey }) => {
//     if (sortConfig.key !== columnKey) {
//       return (
//         <span className="sort-icons">
//           <ArrowDropUpIcon style={{ opacity: 0.3 }} />
//           <ArrowDropDownIcon style={{ opacity: 0.3 }} />
//         </span>
//       );
//     }
//     return sortConfig.direction === 'ascending'
//       ? <ArrowDropUpIcon />
//       : <ArrowDropDownIcon />;
//   };

//   const formattedFromDateForAPI = formatDateForAPI(fromDate);
//   const formattedToDateForAPI = formatDateForAPI(toDate);

//   // Prepare the vertical parameter for the API
//   const verticalParam = selectedVertical || "ALL";

//   // Updated API URL to include segment and vertical if selected
//   const API_URL = `${local_url}/api/GTSaleMovementReport/getGTOrderMovementListing/${selectedSegment}/${verticalParam}/${selectedSFAreaId}/${formattedFromDateForAPI}/${formattedToDateForAPI}`;

//   const fetchLedgerData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await fetch(API_URL);
//       if (!response.ok) throw new Error("Network response was not ok");
//       const data = await response.json();
//       setLedgerData(data);
//       setFilteredData(data);
//       setCurrentPage(1); // Reset to first page when new data is fetched
//     } catch (error) {
//       setError("Failed to fetch ledger data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = (event) => {
//     const query = event.target.value.toLowerCase();
//     setSearchQuery(query);

//     const filtered = ledgerData.filter((item) =>
//       (item.customerName?.toLowerCase() || "").includes(query) ||
//       (item.saleId?.toLowerCase() || "").includes(query) ||
//       (item.customerCode?.toLowerCase() || "").includes(query)
//     );

//     setFilteredData(filtered);
//     setCurrentPage(1); // Reset to first page on new search
//   };

//   const exportToCSV = () => {
//     const csvRows = [];

//     const headers = [
//       "Sr No",
//       "Customer Code",
//       "Customer Name",
//       "Bill No",
//       "Promo Code",
//       "Credit Limit",
//       "Credit Days",
//       "Bill Date",
//       "Bill Time",
//       "Sale Qty",
//       "Sale Amount",
//       "Sale Return Qty",
//       "Sale Return Amount",
//       "Amt Receipt",
//       "Balance",
//       "Bill Cleared",
//       "Delivery Date",
//       "Delivery Time",
//       "Delivery Confirm Date",
//       "Delivery Confirm Time",
//       "SR Pickup Date",
//       "SR Pickup Time",
//       "SR Approve Date",
//       "SR Approve Time",
//       "SR POS Accepted Date",
//       "SR POS Accepted Time",
//     ];
//     csvRows.push(headers.join(","));

//     const processedData = [...ledgerData]
//       .sort((a, b) => {
//         if (a.saleId && b.saleId) {
//           return a.saleId.localeCompare(b.saleId);
//         } else if (!a.saleId) {
//           return 1;
//         } else if (!b.saleId) {
//           return -1;
//         }
//         return 0;
//       })
//       .reduce((acc, item) => {
//         const existingItemIndex = acc.findIndex(x => x.saleId === item.saleId);

//         if (existingItemIndex !== -1) {
//           const previousItem = acc[existingItemIndex];
//           const newBalance = previousItem.balance - (item.srTotalAmount || 0);

//           return [
//             ...acc.slice(0, existingItemIndex + 1),
//             {
//               ...item,
//               balance: newBalance,
//               isSubsequentEntry: true
//             }
//           ];
//         } else {
//           const balance = (item.totalAmount || 0) - (item.srTotalAmount || 0) - (item.billReceipt || 0);
//           return [...acc, { ...item, balance, isSubsequentEntry: false }];
//         }
//       }, []);

//     processedData.forEach((item, index) => {
//       const row = [
//         index + 1,
//         item.customerCode || "-",
//         item.customerName || "-",
//         item.saleId || "-",
//         item.promoCodes || "-",
//         `${item.creditLimit?.toFixed(2) || "0.00"}`,
//         item.creditDays || "0",

//         formatDateTime(item.billingDateTime, "date"),
//         formatDateTime(item.billingDateTime, "time"),
//         item.totalQty || "0",
//         `${item.totalAmount?.toFixed(2) || "0.00"}`,
//         item.srTotalQty || "0",
//         `${item.srTotalAmount?.toFixed(2) || "0.00"}`,
//         `${item.billReceipt?.toFixed(2) || "0.00"}`,
//         `${item.balance.toFixed(2)}`,
//         item.balance <= 0 ? "Y" : "N",
//         formatDateTime(item.deliveryDateTime, "date"),
//         formatDateTime(item.deliveryDateTime, "time"),
//         formatDateTime(item.deliveryApproveDateTime, "date"),
//         formatDateTime(item.deliveryApproveDateTime, "time"),
//         formatDateTime(item.srPickUpDateTime, "date"),
//         formatDateTime(item.srPickUpDateTime, "time"),
//         formatDateTime(item.srApproveDateTime, "date"),
//         formatDateTime(item.srApproveDateTime, "time"),
//         formatDateTime(item.srAcceptDateTime, "date"),
//         formatDateTime(item.srAcceptDateTime, "time"),
//       ];

//       csvRows.push(row.join(","));
//     });

//     const csvContent = "\uFEFF" + csvRows.join("\n");
//     const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "gt_order_movement_report.csv");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Handlers for the new dropdowns
//   const handleSegmentChange = (event) => {
//     setSelectedSegment(event.target.value);
//   };

//   const handleVerticalChange = (event) => {
//     setSelectedVertical(event.target.value);
//   };

//   const handleSfAreaChange = (event) => {
//     setSelectedSFAreaId(event.target.value);
//   };

//   // Pagination logic
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  
//   const processedFilteredData = [...filteredData]
//     .sort((a, b) => {
//       if (a.saleId && b.saleId) {
//         const saleIdCompare = a.saleId.localeCompare(b.saleId);
//         if (saleIdCompare !== 0) return saleIdCompare;

//         if (a.srTotalAmount && !b.srTotalAmount) return 1;
//         if (!a.srTotalAmount && b.srTotalAmount) return -1;

//         return new Date(a.billingDateTime) - new Date(b.billingDateTime);
//       } else if (!a.saleId) {
//         return 1;
//       } else if (!b.saleId) {
//         return -1;
//       }
//       return 0;
//     })
//     .reduce((acc, item) => {
//       const existingEntries = acc.filter(x => x.saleId === item.saleId);

//       if (existingEntries.length > 0) {
//         const lastEntry = existingEntries[existingEntries.length - 1];
//         const newBalance = lastEntry.balance - (item.srTotalAmount || 0);

//         const lastIndex = acc.indexOf(lastEntry);
//         return [
//           ...acc.slice(0, lastIndex + 1),
//           {
//             ...item,
//             balance: newBalance,
//             isSubsequentEntry: true
//           }
//         ];
//       } else {
//         const balance = (item.totalAmount || 0) - (item.srTotalAmount || 0) - (item.billReceipt || 0);
//         return [...acc, { ...item, balance, isSubsequentEntry: false }];
//       }
//     }, []);

//   // Get current records
//   const currentRecords = getSortedData(processedFilteredData).slice(indexOfFirstRecord, indexOfLastRecord);
  
//   // Logic for displaying page numbers
//   const totalPages = Math.ceil(processedFilteredData.length / recordsPerPage);
  
//   // Create page numbers array for pagination
//   const getPageNumbers = () => {
//     const maxPageNumbersToShow = 5;
//     const pageNumbers = [];
    
//     if (totalPages <= maxPageNumbersToShow) {
//       // If we have 5 or fewer pages, show all page numbers
//       for (let i = 1; i <= totalPages; i++) {
//         pageNumbers.push(i);
//       }
//     } else {
//       // Always include first page
//       pageNumbers.push(1);
      
//       // Calculate start and end of page numbers to show
//       let startPage = Math.max(2, currentPage - 1);
//       let endPage = Math.min(totalPages - 1, currentPage + 1);
      
//       // Adjust if at the beginning
//       if (currentPage <= 2) {
//         endPage = Math.min(4, totalPages - 1);
//       }
      
//       // Adjust if at the end
//       if (currentPage >= totalPages - 1) {
//         startPage = Math.max(2, totalPages - 3);
//       }
      
//       // Add ellipsis after page 1 if needed
//       if (startPage > 2) {
//         pageNumbers.push('...');
//       }
      
//       // Add middle pages
//       for (let i = startPage; i <= endPage; i++) {
//         pageNumbers.push(i);
//       }
      
//       // Add ellipsis before last page if needed
//       if (endPage < totalPages - 1) {
//         pageNumbers.push('...');
//       }
      
//       // Always include last page
//       pageNumbers.push(totalPages);
//     }
    
//     return pageNumbers;
//   };
  
//   const pageNumbers = getPageNumbers();
  
//   // Change page
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // Fullscreen loading overlay
//   const LoadingOverlay = () => (
//     <div style={{ 
//       position: 'fixed', 
//       top: 0, 
//       left: 0, 
//       width: '100%', 
//       height: '100%', 
//       backgroundColor: 'rgba(255,255,255,0.7)', 
//       display: 'flex', 
//       justifyContent: 'center', 
//       alignItems: 'center',
//       zIndex: 9999
//     }}>
//       <CircularProgress size={60} />
//     </div>
//   );

//   // Check if segment is MODERN (GTMT)
//   const isGTMTSegment = (code) => code === "MODERN";

//   return (
//     <>
//       <Header />
//       {loading && <LoadingOverlay />}
//       <div className="gt-customer-container">
//         <div className="gt-customer-controls-wrapper">
//           <div className="gt-customer-date-input-container">
//             {/* Business Segment Dropdown - MODERN (GTMT) is selected and disabled */}
//             <select
//               className="gt-customer-dropdown"
//               value={selectedSegment}
//               onChange={handleSegmentChange}
//               disabled={isGTMTSegment(selectedSegment)} // Disable when MODERN is selected
//             >
//               {businessSegments.map((segment) => (
//                 <option 
//                   key={segment.businessSegmentCode} 
//                   value={segment.businessSegmentCode}
//                 >
//                   {segment.businessSegmentName}
//                 </option>
//               ))}
//             </select>

//             {/* Business Vertical Dropdown - Only enabled when a segment is selected and not ALL */}
//             <select
//               className="gt-customer-dropdown"
//               value={selectedVertical}
//               onChange={handleVerticalChange}
//               disabled={!selectedSegment || selectedSegment === "ALL"}
//             >
//               {businessVerticals.map((vertical) => (
//                 <option key={vertical.businessVerticalCode} value={vertical.businessVerticalCode}>
//                   {vertical.businessVerticalName} {vertical.businessVerticalCode !== "ALL" ? `(${vertical.businessVerticalCode})` : ""}
//                 </option>
//               ))}
//             </select>

//             {/* SF Area Dropdown with ALL option */}
//             <select
//               className="gt-customer-dropdown"
//               value={selectedSFAreaId}
//               onChange={handleSfAreaChange}
//             >
//               {sfAreas.map((area) => (
//                 <option key={area.SFAreaId} value={area.SFAreaId}>
//                   {area.SFAreaName} {area.SFAreaId !== "ALL" ? `(${area.SFAreaId})` : ""}
//                 </option>
//               ))}
//             </select>

//             {/* Wrap DatePickers with LocalizationProvider */}
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DatePicker
//                 value={fromDate}
//                 onChange={handleFromDateChange}
//                 format="DD-MM-YYYY"
//                 sx={datePickerStyle}
//                 slotProps={{
//                   textField: {
//                     size: "small",
//                     variant: "outlined"
//                   }
//                 }}
//               />
              
              
//               <DatePicker
//                 value={toDate}
//                 onChange={handleToDateChange}
//                 format="DD-MM-YYYY"
//                 sx={datePickerStyle}
//                 slotProps={{
//                   textField: {
//                     size: "small",
//                     variant: "outlined"
//                   }
//                 }}
//               />
//             </LocalizationProvider>

//             <button
//               onClick={fetchLedgerData}
//               className="gt-customer-submit-button"
//               disabled={loading}
//             >
//               Submit
//             </button>
//             <button
//               onClick={exportToCSV}
//               className="gt-customer-export-button"
//               disabled={loading || ledgerData.length === 0}
//             >
//               Export to CSV
//             </button>

//             <div className="gt-customer-search-pagination-container">
//             <div className="gt-customer-search-container">
//               <input
//                 type="text"
//                 placeholder="Search by Customer Name or Sale ID"
//                 value={searchQuery}
//                 onChange={handleSearch}
//                 className="gt-customer-search-input"
//               />
           
            
//             {filteredData.length > recordsPerPage && (
//               <div className="pagination-container">
//                 <button
//                   onClick={() => paginate(1)}
//                   disabled={currentPage === 1}
//                   className="pagination-button"
//                 >
//                   First
//                 </button>
//                 <button
//                   onClick={() => paginate(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   className="pagination-button"
//                 >
//                   Prev
//                 </button>
                
//                 {pageNumbers.map((number, index) => (
//                   number === '...' ? 
//                   <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span> :
//                   <button
//                     key={number}
//                     onClick={() => paginate(number)}
//                     className={`pagination-button ${currentPage === number ? 'pagination-active' : ''}`}
//                   >
//                     {number}
//                   </button>
//                 ))}
                
//                 <button
//                   onClick={() => paginate(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                   className="pagination-button"
//                 >
//                   Next
//                 </button>
//                 <button
//                   onClick={() => paginate(totalPages)}
//                   disabled={currentPage === totalPages}
//                   className="pagination-button"
//                 >
//                   Last
//                 </button>
                
//                 <span className="pagination-info">
//                   Page {currentPage} of {totalPages}
//                 </span>
//               </div>
//             )}
//              </div>
//           </div>
//           </div>
//         </div>

//         <div className="gt-customer-table-container">
//           <div className="gt-customer-table-scroll">
//             <table className="gt-customer-table">
//               <thead>
//                 <tr>
//                   <th onClick={() => handleSort('index')}>
//                     S No. <SortIcon columnKey="index" />
//                   </th>
//                   <th onClick={() => handleSort('customerCode')}>
//                     Customer Code <SortIcon columnKey="customerCode" />
//                   </th>
//                   <th onClick={() => handleSort('customerName')}>
//                     Customer Name <SortIcon columnKey="customerName" />
//                   </th>
//                   <th onClick={() => handleSort('promoCodes')}>
//                     Promo Code <SortIcon columnKey="promoCodes" />
//                   </th>
//                   <th onClick={() => handleSort('saleId')}>
//                     Bill No <SortIcon columnKey="saleId" />
//                   </th>
//                   <th>
//                     Credit Limit
//                   </th>
//                   <th>
//                     Credit Days
//                   </th>
//                   <th>
//                     Bill Date
//                   </th>
//                   <th>
//                     Bill Time
//                   </th>
//                   <th>Sale Qty</th>
//                   <th>Sale Amount</th>
//                   <th>Sale Return Qty</th>
//                   <th>Sale Return Amount</th>
//                   <th>Amt Receipt</th>
//                   <th>Balance</th>
//                   <th>Bill Cleared</th>
//                   <th>Delivery Date</th>
//                   <th>Delivery Time</th>
//                   <th>Delivery Confirm Date</th>
//                   <th>Delivery Confirm Time</th>
//                   <th>SR Pickup Date</th>
//                   <th>SR Pickup Time</th>
//                   <th>SR Approve Date</th>
//                   <th>SR Approve Time</th>
//                   <th>SR POS Return Date</th>
//                   <th>SR POS Return Time</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="25" className="gt-customer-loading-container">
//                       <CircularProgress />
//                     </td>
//                   </tr>
//                 ) : currentRecords.length > 0 ? (
//                   currentRecords.map((item, index) => {
//                     const actualIndex = indexOfFirstRecord + index;
//                     const billingDate = formatDateTime(item.billingDateTime, "date");
//                     const billingTime = formatDateTime(item.billingDateTime, "time");
//                     const deliveryDate = formatDateTime(item.deliveryDateTime, "date");
//                     const deliveryTime = formatDateTime(item.deliveryDateTime, "time");
//                     const deliveryApproveDate = formatDateTime(item.deliveryApproveDateTime, "date");
//                     const deliveryApproveTime = formatDateTime(item.deliveryApproveDateTime, "time");
//                     const srPickUpDate = formatDateTime(item.srPickUpDateTime, "date");
//                     const srPickUpTime = formatDateTime(item.srPickUpDateTime, "time");
//                     const srApproveDate = formatDateTime(item.srApproveDateTime, "date");
//                     const srApproveTime = formatDateTime(item.srApproveDateTime, "time");
//                     const srAcceptedDate = formatDateTime(item.srAcceptDateTime, "date");
//                     const srAcceptedTime = formatDateTime(item.srAcceptDateTime, "time");
//                     const cleared = item.balance <= 0 ? "Y" : "N";

//                     return (
//                       <tr key={actualIndex}>
//                         <td>{actualIndex + 1}</td>
//                         <td>{item.customerCode || "-"}</td>
//                         <td>{item.customerName || "-"}</td>
//                         <td>{item.promoCodes || "-"}</td>
//                         <td>{item.saleId || "-"}</td>
//                         <td>₹{item.creditLimit?.toFixed(2) || "0.00"}</td>
//                         <td>{item.creditDays || "0"}</td>
//                         <td>{billingDate}</td>
//                         <td>{billingTime}</td>
//                         <td>{item.totalQty || "0"}</td>
//                         <td>₹{item.totalAmount?.toFixed(2) || "0.00"}</td>
//                         <td>{item.srTotalQty || "0"}</td>
//                         <td>₹{item.srTotalAmount?.toFixed(2) || "0.00"}</td>
//                         <td>₹{item.billReceipt?.toFixed(2) || "0.00"}</td>
//                         <td>₹{item.balance.toFixed(2)}</td>
//                         <td>{cleared}</td>
//                         <td>{deliveryDate}</td>
//                         <td>{deliveryTime}</td>
//                         <td>{deliveryApproveDate}</td>
//                         <td>{deliveryApproveTime}</td>
//                         <td>{srPickUpDate}</td>
//                         <td>{srPickUpTime}</td>
//                         <td>{srApproveDate}</td>
//                         <td>{srApproveTime}</td>
//                         <td>{srAcceptedDate}</td>
//                         <td>{srAcceptedTime}</td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan="25" className="gt-customer-no-data">
//                       No data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//       <style>{`
//         /* Pagination Styles */
//         .pagination-container {
//           margin: 15px 0;
//           margin-left: 30px;
//         }
//         .pagination-button {
//           padding: 5px 10px;
//           margin: 0 2px;
//           border: 1px solid #ccc;
//           background: #f5f5f5;
//           cursor: pointer;
//           color: black;
//         }
//         .pagination-button:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }
//         .pagination-active {
//           background: #004D00;
//           color: white;
//           border-color: #004D00;
//         }
//         .data-count {
//           margin-left: 15px;
//           font-weight: bold;
//         }
//         .loader-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           margin: 20px 0;
//         }
//         .date-picker-container {
//           min-width: 180px;
//           margin: 0 5px;
//         }
//         .customer-date-input-container {
//           display: flex;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 10px;
//           margin-bottom: 20px;
//         }

//         /* Enhanced Summary Row Styles */
//         .summary-row {
//           background: linear-gradient(to right, #ffffff 0%, #f8f9fa 100%);
//           transition: all 0.3s ease;
//           border-left: 4px solid transparent;
//         }

//         .summary-row:hover {
//           background: linear-gradient(to right, #e8f5e9 0%, #c8e6c9 100%);
//           border-left: 4px solid #004D00;
//           box-shadow: 0 2px 8px rgba(0, 77, 0, 0.15);
//           transform: translateX(2px);
//         }

//         /* Expand Icon Cell */
//         .expand-cell {
//           cursor: pointer;
//           text-align: center;
//           background: #e8f5e9;
//           border-right: 2px solid #004D00;
//         }

//         .expand-icon {
//           display: inline-block;
//           width: 28px;
//           height: 28px;
//           line-height: 28px;
//           border-radius: 50%;
//           background: #004D00;
//           color: white;
//           font-size: 14px;
//           transition: all 0.3s ease;
//         }

//         .expand-icon:hover {
//           background: #006400;
//           transform: scale(1.15);
//           box-shadow: 0 2px 8px rgba(0, 77, 0, 0.4);
//         }

//         /* Cell Type Styles */
//         .serial-cell {
//           font-weight: 600;
//           color: #424242;
//           text-align: center;
//         }

//         .code-cell {
//           font-family: 'Courier New', monospace;
//           font-size: 12px;
//           color: #004D00;
//           font-weight: 600;
//         }

//         .customer-name-cell {
//           font-weight: 600;
//           color: #004D00;
//           max-width: 200px;
//         }

//         .city-cell {
//           color: #2e7d32;
//           font-weight: 500;
//         }

//         .bill-cell {
//           font-family: 'Courier New', monospace;
//           font-weight: 700;
//           color: #d32f2f;
//           background: #ffebee;
//           text-align: center;
//         }

//         .promo-cell {
//           font-style: italic;
//           color: #f57c00;
//         }

//         .amount-cell {
//           text-align: right;
//           font-weight: 600;
//           font-family: 'Courier New', monospace;
//         }

//         .days-cell {
//           text-align: center;
//           font-weight: 600;
//           color: #6a1b9a;
//         }

//         .date-cell {
//           color: #616161;
//           font-size: 13px;
//         }

//         .time-cell {
//           color: #757575;
//           font-size: 12px;
//           font-style: italic;
//         }

//         /* Quantity and Amount Color Coding */
//         .qty-cell {
//           text-align: center;
//           font-weight: 700;
//         }

//         .sale-qty {
//           color: #2e7d32;
//           background: #e8f5e9;
//         }

//         .sale-amount {
//           color: #2e7d32;
//           background: #e8f5e9;
//         }

//         .return-qty {
//           color: #c62828;
//           background: #ffebee;
//         }

//         .return-amount {
//           color: #c62828;
//           background: #ffebee;
//         }

//         .receipt-amount {
//           color: #004D00;
//           background: #e8f5e9;
//         }

//         /* Balance Cell Styles */
//         .balance-cell {
//           font-weight: 700;
//           font-size: 14px;
//         }

//         .balance-pending {
//           color: #d32f2f;
//           background: #ffcdd2;
//         }

//         .balance-cleared {
//           color: #388e3c;
//           background: #c8e6c9;
//         }

//         /* Cleared Status */
//         .cleared-cell {
//           text-align: center;
//           font-weight: 900;
//           font-size: 14px;
//         }

//         .cleared-yes {
//           color: #388e3c;
//           background: #c8e6c9;
//         }

//         .cleared-no {
//           color: #d32f2f;
//           background: #ffcdd2;
//         }

//         /* Detail Row Styles */
//         .detail-row {
//           background: #f5f5f5;
//           border-left: 4px solid #81c784;
//           animation: slideIn 0.3s ease-out;
//         }

//         .detail-row.has-return {
//           background: linear-gradient(to right, #fff3e0 0%, #ffe0b2 100%);
//           border-left: 4px solid #ff9800;
//         }

//         .detail-row:hover {
//           background: #e8f5e9;
//           transform: translateX(4px);
//           transition: all 0.2s ease;
//         }

//         .detail-row.has-return:hover {
//           background: linear-gradient(to right, #ffe0b2 0%, #ffcc80 100%);
//         }

//         @keyframes slideIn {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         /* Detail Cell Styles */
//         .detail-expand {
//           background: #e8f5e9;
//         }

//         .detail-serial {
//           text-align: center;
//           font-weight: 600;
//           color: #004D00;
//           font-size: 12px;
//         }

//         .item-name-detail {
//           padding-left: 30px !important;
//         }

//         .item-detail-container {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .item-icon {
//           font-size: 18px;
//         }

//         .item-name {
//           font-weight: 700;
//           color: #004D00;
//           font-size: 14px;
//         }

//         .batch-detail {
//           text-align: center;
//         }

//         .batch-badge {
//           display: inline-block;
//           padding: 4px 12px;
//           background: linear-gradient(135deg, #004D00 0%, #006400 100%);
//           color: white;
//           border-radius: 12px;
//           font-size: 11px;
//           font-weight: 700;
//           letter-spacing: 0.5px;
//           box-shadow: 0 2px 4px rgba(0, 77, 0, 0.3);
//         }

//         .detail-qty {
//           text-align: center;
//           font-weight: 700;
//           font-size: 13px;
//         }

//         .detail-amount {
//           text-align: right;
//           font-weight: 700;
//           font-family: 'Courier New', monospace;
//           font-size: 13px;
//         }

//         .sale-detail {
//           color: #2e7d32;
//         }

//         .return-detail {
//           color: #c62828;
//         }

//         /* Table Header Enhancements */
//         .gt-customer-table thead th {
//           background: linear-gradient(to bottom, #004D00 0%, #003300 100%);
//           color: white;
//           font-weight: 700;
//           text-transform: uppercase;
//           font-size: 11px;
//           letter-spacing: 0.5px;
//           border-right: 1px solid rgba(255, 255, 255, 0.1);
//           padding: 12px 8px;
//           position: sticky;
//           top: 0;
//           z-index: 10;
//           box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//         }

//         .gt-customer-table thead th:hover {
//           background: linear-gradient(to bottom, #006400 0%, #004D00 100%);
//         }

//         /* Responsive Design */
//         @media (max-width: 768px) {
//           .date-picker-container {
//             width: 100%;
//             margin: 5px 0;
//           }
//           .customer-date-input-container {
//             flex-direction: column;
//             align-items: stretch;
//           }
//           .item-name {
//             font-size: 12px;
//           }
//           .batch-badge {
//             font-size: 10px;
//             padding: 3px 8px;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default GTOrderMove;





































// // import { useState, useEffect } from 'react';
// // import { 
// //   Box, 
// //   Button, 
// //   Card, 
// //   CardContent, 
// //   Checkbox, 
// //   CircularProgress, 
// //   Container, 
// //   Dialog, 
// //   DialogActions, 
// //   DialogContent, 
// //   DialogTitle, 
// //   Divider, 
// //   FormControl, 
// //   Grid, 
// //   IconButton, 
// //   InputAdornment, 
// //   InputLabel, 
// //   List, 
// //   ListItem, 
// //   MenuItem, 
// //   Paper, 
// //   Select, 
// //   Snackbar, 
// //   Stack, 
// //   Table, 
// //   TableBody, 
// //   TableCell, 
// //   TableContainer, 
// //   TableHead, 
// //   TableRow, 
// //   TextField, 
// //   Typography, 
// //   useTheme,
// //   Tabs,
// //   Tab
// // } from '@mui/material';
// // import Header from '../../Header';

// // // Simple icon components
// // const Icons = {
// //   Add: () => <span style={{ fontSize: '1.25rem' }}></span>,
// //   Remove: () => <span style={{ fontSize: '1.25rem' }}></span>,
// //   Delete: () => <span style={{ fontSize: '1.25rem' }}>🗑️</span>,
// //   Save: () => <span style={{ fontSize: '1.25rem' }}>💾</span>,
// //   ArrowBack: () => <span style={{ fontSize: '1.25rem' }}>←</span>,
// //   Close: () => <span style={{ fontSize: '1.25rem' }}>✕</span>,
// //   Check: () => <span style={{ fontSize: '1.25rem' }}>✓</span>,
// //   ExpandMore: () => <span style={{ fontSize: '1.25rem' }}>▼</span>,
// // };

// // export const GTOrderMove = () => {
// //   const [isModalOpen, setIsModalOpen] = useState(false);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [selectedItem, setSelectedItem] = useState(null);
// //   const [selectedSubItem, setSelectedSubItem] = useState(null);
// //   const [quantity, setQuantity] = useState(1);
// //   const [remark, setRemark] = useState('');
// //   const [tableItems, setTableItems] = useState([]);
// //   const [selectedRows, setSelectedRows] = useState([]);
// //   const [showSubItems, setShowSubItems] = useState(false);
// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMessage, setSnackbarMessage] = useState('');
// //   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
// //   const [subItemsDialogOpen, setSubItemsDialogOpen] = useState(false);
// //   const [activeModalTab, setActiveModalTab] = useState(0);

// //   // Mock data
// //   const mockItems = [
// //     { id: 1, name: "Laptop", subItems: [
// //       { id: 101, name: "MacBook Pro", price: 1299 },
// //       { id: 102, name: "Dell XPS", price: 999 },
// //       { id: 103, name: "Lenovo ThinkPad", price: 899 }
// //     ]},
// //     { id: 2, name: "Phone", subItems: [
// //       { id: 201, name: "iPhone", price: 999 },
// //       { id: 202, name: "Samsung Galaxy", price: 899 },
// //       { id: 203, name: "Google Pixel", price: 799 }
// //     ]},
// //     { id: 3, name: "Tablet", subItems: [
// //       { id: 301, name: "iPad Pro", price: 799 },
// //       { id: 302, name: "Samsung Tab", price: 649 },
// //       { id: 303, name: "Microsoft Surface", price: 899 }
// //     ]}
// //   ];

// //   const locations = [
// //     { id: 1, code: "B101", name: "B101 HO" },
// //     { id: 2, code: "B102", name: "B102 Warehouse" },
// //     { id: 3, code: "B103", name: "B103 Store" }
// //   ];

// //   const [selectedLocation, setSelectedLocation] = useState(locations[0]);

// //   // Function to reset modal state
// //   const resetModalState = () => {
// //     setActiveModalTab(0);
// //     setSelectedItem(null);
// //   };

// //   // Function to update line numbers for all items
// //   const updateLineNumbers = (items) => {
// //     return items.map((item, index) => ({
// //       ...item,
// //       lineNumber: generateLineNumber(index + 1)
// //     }));
// //   };

// //   const openModal = () => {
// //     // Reset modal state when opening
// //     resetModalState();
    
// //     setIsModalOpen(true);
// //     setIsLoading(true);
// //     // Simulate API call
// //     setTimeout(() => {
// //       setIsLoading(false);
// //     }, 800);
// //   };

// //   const closeModal = () => {
// //     setIsModalOpen(false);
// //     setSelectedItem(null);
// //     setActiveModalTab(0);
// //   };

// //   const handleItemSelection = (item) => {
// //     setSelectedItem(item);
    
// //     if (item.name === "Phone") {
// //       // Show phone options directly in the modal
// //       setActiveModalTab(1);
// //     } else {
// //       // Open sub-items dialog for non-phone items
// //       setSubItemsDialogOpen(true);
// //       setIsModalOpen(false);
// //     }
// //   };

// //   const handleSubItemSelection = (subItem) => {
// //     setSelectedSubItem(subItem);
// //     setSubItemsDialogOpen(false);
// //     setIsModalOpen(false);
// //     showSnackbar(`Selected: ${subItem.name}`);
// //   };

// //   const incrementQuantity = () => {
// //     setQuantity(prevQuantity => prevQuantity + 1);
// //   };

// //   const decrementQuantity = () => {
// //     setQuantity(prevQuantity => prevQuantity > 1 ? prevQuantity - 1 : 1);
// //   };

// //   const handleAddItem = () => {
// //     if (!selectedSubItem) return;
    
// //     const newItem = {
// //       id: Date.now(),
// //       lineNumber: generateLineNumber(tableItems.length + 1),
// //       itemName: `${selectedItem.name} - ${selectedSubItem.name}`,
// //       quantity,
// //       price: selectedSubItem.price,
// //       total: selectedSubItem.price * quantity,
// //       remark
// //     };

// //     setTableItems([...tableItems, newItem]);
// //     showSnackbar('Item added successfully');
// //     resetForm();
// //   };

// //   const generateLineNumber = (num) => {
// //     return num.toString().padStart(3, '0');
// //   };

// //   const resetForm = () => {
// //     setSelectedSubItem(null);
// //     setQuantity(1);
// //     setRemark('');
// //   };

// //   const handleCheckboxChange = (id) => {
// //     setSelectedRows(prev => {
// //       if (prev.includes(id)) {
// //         return prev.filter(rowId => rowId !== id);
// //       } else {
// //         return [...prev, id];
// //       }
// //     });
// //   };

// //   const handleDeleteSelected = () => {
// //     setConfirmDialogOpen(true);
// //   };

// //   const confirmDelete = () => {
// //     // Filter out the selected rows
// //     const remainingItems = tableItems.filter(item => !selectedRows.includes(item.id));
    
// //     // Update line numbers for all remaining items
// //     const updatedItems = updateLineNumbers(remainingItems);
    
// //     setTableItems(updatedItems);
// //     setSelectedRows([]);
// //     setConfirmDialogOpen(false);
// //     showSnackbar(`${selectedRows.length} item(s) deleted`);
// //   };

// //   const handleSave = () => {
// //     showSnackbar(`${tableItems.length} items saved successfully!`);
// //     console.log("Saved items:", tableItems);
// //   };

// //   const backToItemSelection = () => {
// //     setActiveModalTab(0);
// //   };

// //   const showSnackbar = (message) => {
// //     setSnackbarMessage(message);
// //     setSnackbarOpen(true);
// //   };

// //   const handleSnackbarClose = () => {
// //     setSnackbarOpen(false);
// //   };

// //   const getTotal = () => {
// //     return tableItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
// //   };

// //   const handleModalTabChange = (event, newValue) => {
// //     setActiveModalTab(newValue);
// //   };

// //   // Enhanced styles
// //   const styles = {
// //     container: {
// //       py: 2, 
// //       mt: 1
// //     },
// //     headerPaper: {
// //       p: 1, 
// //       mb: 0, 
// //       borderRadius: 1,
// //       borderColor: 'black',
// //       boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
// //       color: 'white'
// //     },
// //     headerTitle: {
// //       fontWeight: 'bold', 
// //       mb: 1,
// //       fontSize: '1.75rem'
// //     },
// //     locationSelect: {
// //       mb: 1,
// //       backgroundColor: 'rgba(255, 255, 255, 0.9)',
// //       borderRadius: 1,
// //       '& .MuiOutlinedInput-notchedOutline': {
// //         borderColor: 'black'
// //       },
// //       '&:hover .MuiOutlinedInput-notchedOutline': {
// //         borderColor: 'blue'
// //       }
// //     },
// //     controlPaper: {
// //       p: 2, 
// //       mb: 0, 
// //       borderRadius: 1,
// //       bgcolor: '#fafafa',
// //       boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
// //       border: '1px solid #f0f0f0'
// //     },
// //     backButton: {
// //       backgroundColor: '#f5f5f5',
// //       color: '#333',
// //       '&:hover': {
// //         backgroundColor: '#e0e0e0'
// //       }
// //     },
// //     subItemCard: {
// //       height: '100%',
// //       transition: 'all 0.2s ease',
// //       border: '1px solid #e0e0e0',
// //       '&:hover': { 
// //         transform: 'translateY(-4px)',
// //         boxShadow: '0 8px 16px rgba(25, 118, 210, 0.15)',
// //         borderColor: '#1976d2'
// //       },
// //       cursor: 'pointer'
// //     },
// //     selectItemButton: {
// //       minWidth: '130px',
// //       background: 'linear-gradient(45deg, #2196F3 30%, #1976d2 90%)',
// //       boxShadow: '0 3px 5px rgba(33, 150, 243, 0.3)',
// //       '&:hover': {
// //         boxShadow: '0 5px 8px rgba(33, 150, 243, 0.5)'
// //       }
// //     },
// //     itemField: {
// //       '& .MuiOutlinedInput-root': {
// //         background: '#f8f8f8'
// //       }
// //     },
// //     quantityField: {
// //       '& .MuiOutlinedInput-root': {
// //         background: '#f8f8f8'
// //       }
// //     },
// //     addButton: {
// //       px: 3,
// //       py: 1,
// //       background: 'linear-gradient(45deg, #4caf50 30%, #2e7d32 90%)',
// //       boxShadow: '0 3px 5px rgba(76, 175, 80, 0.3)',
// //       '&:hover': {
// //         boxShadow: '0 5px 8px rgba(76, 175, 80, 0.5)'
// //       }
// //     },
// //     tablePaper: {
// //       p: 1, 
// //       borderRadius: 1,
// //       boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
// //     },
// //     tableHeaderCell: {
// //       backgroundColor: '#f5f5f5',
// //       color: '#555',
// //       fontWeight: 'bold',
// //       fontSize: '0.875rem',
// //       padding: '8px 12px'
// //     },
// //     tableBodyRow: {
// //       '&:nth-of-type(odd)': {
// //         backgroundColor: '#fafafa',
// //       },
// //       '&:hover': {
// //         backgroundColor: '#f0f7ff'
// //       }
// //     },
// //     tableCell: {
// //       padding: '6px 12px',
// //       fontSize: '0.875rem'
// //     },
// //     deleteButton: {
// //       background: 'linear-gradient(45deg, #f44336 30%, #d32f2f 90%)',
// //       boxShadow: '0 2px 5px rgba(244, 67, 54, 0.3)',
// //       '&:hover': {
// //         boxShadow: '0 4px 8px rgba(244, 67, 54, 0.5)'
// //       }
// //     },
// //     saveButton: {
// //       background: 'linear-gradient(45deg, #1976d2 30%, #0d47a1 90%)',
// //       boxShadow: '0 2px 5px rgba(25, 118, 210, 0.3)',
// //       '&:hover': {
// //         boxShadow: '0 4px 8px rgba(25, 118, 210, 0.5)'
// //       }
// //     },
// //     modalDialog: {
// //       '& .MuiDialog-paper': {
// //         borderRadius: 1,
// //         boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)'
// //       }
// //     },
// //     modalTitle: {
// //       backgroundColor: '#f5f5f5',
// //       padding: '12px 20px'
// //     },
// //     modalItemList: {
// //       padding: 0
// //     },
// //     modalListItem: {
// //       borderRadius: 1,
// //       mb: 1,
// //       border: '1px solid #e0e0e0',
// //       transition: 'all 0.2s ease',
// //       '&:hover': { 
// //         backgroundColor: '#f0f7ff', 
// //         borderColor: '#1976d2',
// //         transform: 'translateX(4px)'
// //       }
// //     },
// //     modalPhoneOption: {
// //       border: '1px solid #e0e0e0',
// //       borderRadius: 1,
// //       p: 1,
// //       mb: 1,
// //       cursor: 'pointer',
// //       transition: 'all 0.2s ease',
// //       '&:hover': {
// //         backgroundColor: '#f0f7ff',
// //         borderColor: '#1976d2',
// //         transform: 'translateY(-2px)',
// //         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
// //       }
// //     },
// //     confirmDialog: {
// //       '& .MuiDialog-paper': {
// //         borderRadius: 1,
// //         overflow: 'hidden'
// //       }
// //     },
// //     confirmTitle: {
// //       backgroundColor: '#f44336',
// //       color: 'white',
// //       padding: '12px 16px'
// //     },
// //     snackbar: {
// //       '& .MuiSnackbarContent-root': {
// //         backgroundColor: '#333',
// //         boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)'
// //       }
// //     },
// //     modalTabs: {
// //       borderBottom: '1px solid #e0e0e0',
// //       '& .MuiTab-root': {
// //         minHeight: '48px',
// //         textTransform: 'none',
// //         fontWeight: 'medium',
// //         fontSize: '0.875rem'
// //       },
// //       '& .Mui-selected': {
// //         color: '#1976d2',
// //         fontWeight: 'bold'
// //       },
// //       '& .MuiTabs-indicator': {
// //         backgroundColor: '#1976d2',
// //         height: '3px'
// //       }
// //     }
// //   };

// //   return (
// //     <>
// //     <Header/>
// //     <Container maxWidth="lg" sx={styles.container}>
 
// //       <Paper elevation={0} sx={styles.headerPaper}>
// //         {/* <Typography variant="h4" component="h1" sx={styles.headerTitle}>
// //           Order Management System
// //         </Typography> */}
// //         {/* <Divider sx={{ mb: 2, opacity: 0.3 }} /> */}
        
// //         {/* Location Dropdown */}
// //         <FormControl fullWidth size="small" sx={styles.locationSelect}>
// //           <InputLabel id="location-select-label">Location</InputLabel>
// //           <Select
// //             labelId="location-select-label"
// //             id="location-select"
// //             value={selectedLocation.id}
// //             label="Location"
// //             onChange={(e) => {
// //               const loc = locations.find(l => l.id === e.target.value);
// //               setSelectedLocation(loc || locations[0]);
// //             }}
// //           >
// //             {locations.map((location) => (
// //               <MenuItem key={location.id} value={location.id}>
// //                 {location.name}
// //               </MenuItem>
// //             ))}
// //           </Select>
// //         </FormControl>
// //       </Paper>

// //       {/* Main controls */}
// //       <Paper elevation={0} sx={styles.controlPaper}>
// //         <Box>
// //           {/* Item Selection */}
// //           <Grid container spacing={2}>
// //             <Grid item xs={12} md={6}>
// //               <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 'medium' }}>Item</Typography>
// //               <Stack direction="row" spacing={1}>
// //                 <Button 
// //                   variant="contained"
// //                   size="small"
// //                   onClick={openModal}
// //                   sx={styles.selectItemButton}
// //                 >
// //                   Select Item
// //                 </Button>
// //                 <TextField
// //                   fullWidth
// //                   size="small"
// //                   variant="outlined"
// //                   value={selectedSubItem ? `${selectedItem?.name} - ${selectedSubItem?.name}` : "No item selected"}
// //                   InputProps={{
// //                     readOnly: true,
// //                   }}
// //                   sx={styles.itemField}
// //                 />
// //               </Stack>
// //             </Grid>

// //             {/* Quantity */}
// //             <Grid item xs={12} md={3}>
// //               <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 'medium' }}>Quantity</Typography>
// //               <TextField
// //                 fullWidth
// //                 size="small"
// //                 type="number"
// //                 value={quantity}
// //                 onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
// //                 InputProps={{
// //                   startAdornment: (
// //                     <InputAdornment position="start">
// //                       <IconButton onClick={decrementQuantity} edge="start" size="small" sx={{ p: 0.5 }}>
// //                         <Icons.Remove />
// //                       </IconButton>
// //                     </InputAdornment>
// //                   ),
// //                   endAdornment: (
// //                     <InputAdornment position="end">
// //                       <IconButton onClick={incrementQuantity} edge="end" size="small" sx={{ p: 0.5 }}>
// //                         <Icons.Add />
// //                       </IconButton>
// //                     </InputAdornment>
// //                   )
// //                 }}
// //                 sx={styles.quantityField}
// //               />
// //             </Grid>

// //             {/* Remark */}
// //             <Grid item xs={12} md={3}>
// //               <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 'medium' }}>Remark</Typography>
// //               <TextField
// //                 fullWidth
// //                 size="small"
// //                 variant="outlined"
// //                 placeholder="Notes"
// //                 value={remark}
// //                 onChange={(e) => setRemark(e.target.value)}
// //                 sx={styles.remarkField}
// //               />
// //             </Grid>
// //           </Grid>

// //           {/* Add Button */}
// //           <Box sx={{ mt: 2, textAlign: 'right' }}>
// //             <Button 
// //               variant="contained" 
// //               color="success"
// //               size="small"
// //               startIcon={<Icons.Add />}
// //               onClick={handleAddItem}
// //               disabled={!selectedSubItem}
// //               sx={styles.addButton}
// //             >
// //               Add Item
// //             </Button>
// //           </Box>
// //         </Box>
// //       </Paper>

// //       {/* Table */}
// //       <Paper elevation={0} sx={styles.tablePaper}>
// //         <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
// //           <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>Item List</Typography>
// //           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
// //             Total: ${getTotal().toFixed(2)}
// //           </Typography>
// //         </Stack>
// //         <TableContainer sx={{ height: '35vh', border: '1px solid #e0e0e0', borderRadius: 1 }}>
// //           <Table stickyHeader size="small">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell padding="checkbox" sx={styles.tableHeaderCell}>
// //                   <Checkbox
// //                     size="small"
// //                     indeterminate={selectedRows.length > 0 && selectedRows.length < tableItems.length}
// //                     checked={tableItems.length > 0 && selectedRows.length === tableItems.length}
// //                     onChange={() => {
// //                       if (selectedRows.length === tableItems.length) {
// //                         setSelectedRows([]);
// //                       } else {
// //                         setSelectedRows(tableItems.map(item => item.id));
// //                       }
// //                     }}
// //                   />
// //                 </TableCell>
// //                 <TableCell sx={styles.tableHeaderCell}>Line #</TableCell>
// //                 <TableCell sx={styles.tableHeaderCell}>Item Name</TableCell>
// //                 <TableCell align="right" sx={styles.tableHeaderCell}>Price</TableCell>
// //                 <TableCell align="right" sx={styles.tableHeaderCell}>Qty</TableCell>
// //                 <TableCell align="right" sx={styles.tableHeaderCell}>Total</TableCell>
// //                 <TableCell sx={styles.tableHeaderCell}>Remark</TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {tableItems.map((item) => (
// //                 <TableRow 
// //                   key={item.id} 
// //                   selected={selectedRows.includes(item.id)}
// //                   hover
// //                   sx={styles.tableBodyRow}
// //                 >
// //                   <TableCell padding="checkbox" sx={styles.tableCell}>
// //                     <Checkbox
// //                       size="small"
// //                       checked={selectedRows.includes(item.id)}
// //                       onChange={() => handleCheckboxChange(item.id)}
// //                     />
// //                   </TableCell>
// //                   <TableCell sx={styles.tableCell}>{item.lineNumber}</TableCell>
// //                   <TableCell sx={styles.tableCell}>{item.itemName}</TableCell>
// //                   <TableCell align="right" sx={styles.tableCell}>${item.price}</TableCell>
// //                   <TableCell align="right" sx={styles.tableCell}>{item.quantity}</TableCell>
// //                   <TableCell align="right" sx={{...styles.tableCell, fontWeight: 'medium'}}>${(item.price * item.quantity).toFixed(2)}</TableCell>
// //                   <TableCell sx={styles.tableCell}>{item.remark}</TableCell>
// //                 </TableRow>
// //               ))}
// //               {tableItems.length === 0 && (
// //                 <TableRow>
// //                   <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
// //                     <Typography color="text.secondary" variant="body2">
// //                       No items added yet. Select an item to begin.
// //                     </Typography>
// //                   </TableCell>
// //                 </TableRow>
// //               )}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //         <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
// //           <Button 
// //             variant="contained" 
// //             color="error"
// //             size="small"
// //             startIcon={<Icons.Delete />}
// //             onClick={handleDeleteSelected}
// //             disabled={selectedRows.length === 0}
// //             sx={styles.deleteButton}
// //           >
// //             Delete ({selectedRows.length})
// //           </Button>
// //           <Button 
// //             variant="contained"
// //             color="primary"
// //             size="small"
// //             startIcon={<Icons.Save />}
// //             onClick={handleSave}
// //             disabled={tableItems.length === 0}
// //             sx={styles.saveButton}
// //           >
// //             Save Order
// //           </Button>
// //         </Box>
// //       </Paper>

// //       {/* Item Selection Modal */}
// //       <Dialog
// //         open={isModalOpen}
// //         onClose={closeModal}
// //         maxWidth="sm"
// //         fullWidth
// //         sx={styles.modalDialog}
// //       >
// //         <DialogTitle sx={styles.modalTitle}>
// //           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
// //             {activeModalTab === 0 ? 'Select Item' : 'Select Phone Option'}
// //           </Typography>
// //           {activeModalTab === 1 && (
// //             <Button 
// //               size="small" 
// //               startIcon={<Icons.ArrowBack />} 
// //               onClick={backToItemSelection}
// //               sx={{ mt: -1 }}
// //             >
// //               Back to items
// //             </Button>
// //           )}
// //         </DialogTitle>
// //         <DialogContent sx={{ p: 1 }}>
// //           {activeModalTab === 0 ? (
// //             // Main Items Tab
// //             isLoading ? (
// //               <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
// //                 <CircularProgress size={30} />
// //               </Box>
// //             ) : (
// //               <List sx={styles.modalItemList}>
// //                 {mockItems.map((item) => (
// //                   <ListItem 
// //                     key={item.id}
// //                     button
// //                     onClick={() => handleItemSelection(item)}
// //                     sx={styles.modalListItem}
// //                   >
// //                     <Box sx={{ py: 0.5 }}>
// //                       <Typography variant="subtitle2">{item.name}</Typography>
// //                       <Typography variant="caption" color="text.secondary">
// //                         {item.subItems.length} options available
// //                       </Typography>
// //                     </Box>
// //                   </ListItem>
// //                 ))}
// //               </List>
// //             )
// //           ) : (
// //             // Phone Options Tab
// //             <Grid container spacing={1} sx={{ pt: 1 }}>
// //               {mockItems.find(item => item.name === "Phone")?.subItems.map(phoneOption => (
// //                 <Grid item xs={12} sm={6} key={phoneOption.id}>
// //                   <Box 
// //                     sx={styles.modalPhoneOption}
// //                     onClick={() => {
// //                       setSelectedItem(mockItems.find(item => item.name === "Phone"));
// //                       handleSubItemSelection(phoneOption);
// //                     }}
// //                   >
// //                     <Typography variant="subtitle2">{phoneOption.name}</Typography>
// //                     <Stack direction="row" justifyContent="space-between" alignItems="center">
// //                       <Typography variant="caption" color="text.secondary">
// //                         Model
// //                       </Typography>
// //                       <Typography variant="subtitle2" color="primary">
// //                         ${phoneOption.price}
// //                       </Typography>
// //                     </Stack>
// //                   </Box>
// //                 </Grid>
// //               ))}
// //             </Grid>
// //           )}
// //         </DialogContent>
// //         <DialogActions sx={{ p: 1 }}>
// //           <Button onClick={closeModal} size="small">
// //             Cancel
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
      
// //       {/* Sub-Items Dialog for non-phone items */}
// //       <Dialog
// //         open={subItemsDialogOpen}
// //         onClose={() => setSubItemsDialogOpen(false)}
// //         maxWidth="sm"
// //         fullWidth
// //         sx={styles.modalDialog}
// //       >
// //         <DialogTitle sx={styles.modalTitle}>
// //           <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
// //             Select {selectedItem?.name} Option
// //           </Typography>
// //         </DialogTitle>
// //         <DialogContent sx={{ p: 1 }}>
// //           <Grid container spacing={1} sx={{ pt: 1 }}>
// //             {selectedItem?.subItems.map(subItem => (
// //               <Grid item xs={12} sm={6} key={subItem.id}>
// //                 <Box 
// //                   sx={styles.modalPhoneOption}
// //                   onClick={() => handleSubItemSelection(subItem)}
// //                 >
// //                   <Typography variant="subtitle2">{subItem.name}</Typography>
// //                   <Stack direction="row" justifyContent="space-between" alignItems="center">
// //                     <Typography variant="caption" color="text.secondary">
// //                       {selectedItem?.name}
// //                     </Typography>
// //                     <Typography variant="subtitle2" color="primary">
// //                       ${subItem.price}
// //                     </Typography>
// //                   </Stack>
// //                 </Box>
// //               </Grid>
// //             ))}
// //           </Grid>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 1 }}>
// //           <Button onClick={() => setSubItemsDialogOpen(false)} size="small">
// //             Cancel
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* Confirmation Dialog */}
// //       <Dialog
// //         open={confirmDialogOpen}
// //         onClose={() => setConfirmDialogOpen(false)}
// //         sx={styles.confirmDialog}
// //       >
// //         <DialogTitle sx={styles.confirmTitle}>
// //           <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 'medium' }}>
// //             Confirm Deletion
// //           </Typography>
// //         </DialogTitle>
// //         <DialogContent sx={{ pt: 2 }}>
// //           <Typography variant="body2">
// //             Are you sure you want to delete {selectedRows.length} selected item(s)?
// //           </Typography>
// //         </DialogContent>
// //         <DialogActions sx={{ p: 1 }}>
// //           <Button onClick={() => setConfirmDialogOpen(false)} size="small">
// //             Cancel
// //           </Button>
// //           <Button onClick={confirmDelete} color="error" variant="contained" size="small">
// //             Delete
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* Snackbar for notifications */}
// //       <Snackbar
// //         open={snackbarOpen}
// //         autoHideDuration={2000}
// //         onClose={handleSnackbarClose}
// //         message={snackbarMessage}
// //         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
// //         sx={styles.snackbar}
// //       />
// //     </Container>
// //     </>
// //   );
// // };

//Amitesh singh 1310







import React, { useState, useEffect } from "react";
import { Header } from "../../Header";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./gtcustomer.css";
import { local_signage, local_url } from "../../Const";

const formatDateForInput = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateForAPI = (date) => {
  if (typeof date === 'string' && date.includes('-')) {
    return date.replace(/-/g, "");
  }
  const d = dayjs(date);
  return d.format('YYYYMMDD');
};

const formatDateTime = (dateTime, formatType) => {
  if (!dateTime || dateTime === "1753-01-01T00:00:00") return "-";
  const date = new Date(dateTime);
  if (formatType === "date") {
    const year = String(date.getFullYear()).slice(-2);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${year}`;
  }
  if (formatType === "time") {
    return `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}`;
  }
  return "-";
};

export const GTOrderMove = () => {
  const today = new Date();
  const sixtyDaysAgo = new Date(today);
  sixtyDaysAgo.setDate(today.getDate() - 1);
  const [sfAreas, setSfAreas] = useState([{ SFAreaId: "ALL", SFAreaName: "ALL" }]);
  const [selectedSFAreaId, setSelectedSFAreaId] = useState("ALL");
  const userId = localStorage.getItem("userId");

  const [businessSegments, setBusinessSegments] = useState([]);
  const [businessVerticals, setBusinessVerticals] = useState([{ businessVerticalCode: "ALL", businessVerticalName: "ALL" }]);
  const [selectedSegment, setSelectedSegment] = useState("MODERN");
  const [selectedVertical, setSelectedVertical] = useState("ALL");

  const [ledgerData, setLedgerData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState(dayjs(sixtyDaysAgo));
  const [toDate, setToDate] = useState(dayjs(today));
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending'
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(100);
  const [expandedRows, setExpandedRows] = useState(new Set());

  const datePickerStyle = {
    width: 170,
    margin: "0 8px"
  };

  const calculateDateLimits = (startDate) => {
    const start = dayjs(startDate);
    let maxDate = start.add(2, 'month');
    if (maxDate.isAfter(dayjs())) {
      maxDate = dayjs();
    }
    return { maxDate };
  };

  const handleFromDateChange = (newValue) => {
    setFromDate(newValue);
    const maxAllowedDate = dayjs(newValue).add(2, 'month');
    if (dayjs(toDate).isAfter(maxAllowedDate)) {
      setToDate(maxAllowedDate);
    }
  };

  const handleToDateChange = (newValue) => {
    setToDate(newValue);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const fetchBusinessSegments = async () => {
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const response = await fetch(`${local_url}/api/BizSegments`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error("Failed to fetch Business Segments");
      const data = await response.json();
      const segmentsWithAll = [
        { businessSegmentCode: "ALL", businessSegmentName: "ALL", deleted: "N" },
        ...data
      ];
      setBusinessSegments(segmentsWithAll);
    } catch (error) {
      setError("Failed to fetch Business Segments. Please try again later.");
    }
  };

  const fetchBusinessVerticals = async (segment) => {
    if (!segment || segment === "ALL") {
      setBusinessVerticals([{ businessVerticalCode: "ALL", businessVerticalName: "ALL" }]);
      return;
    }
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const response = await fetch(`${local_url}/api/BizVertical/${segment}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error("Failed to fetch Business Verticals");
      const data = await response.json();
      const verticalsWithAll = [
        { businessVerticalCode: "ALL", businessVerticalName: "ALL" },
        ...data
      ];
      setBusinessVerticals(verticalsWithAll);
      setSelectedVertical("ALL");
    } catch (error) {
      setError("Failed to fetch Business Verticals. Please try again later.");
      setBusinessVerticals([{ businessVerticalCode: "ALL", businessVerticalName: "ALL" }]);
    }
  };

  const fetchSfAreas = async () => {
    try {
      if (!selectedSegment || selectedSegment === "ALL") {
        setSfAreas([{ SFAreaId: "ALL", SFAreaName: "ALL" }]);
        return;
      }
      const token = localStorage.getItem('AuthorizationToken');
      const response = await fetch(`${local_signage}/api/v1/sfareabysegment?SegmentCode=${selectedSegment}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error("Failed to fetch SF Areas");
      const data = await response.json();
      const areasWithAll = [
        { SFAreaId: "ALL", SFAreaName: "ALL" },
        ...data
      ];
      setSfAreas(areasWithAll);
      setSelectedSFAreaId("ALL");
    } catch (error) {
      setError("Failed to fetch SF Areas. Please try again later.");
      setSfAreas([{ SFAreaId: "ALL", SFAreaName: "ALL" }]);
    }
  };

  useEffect(() => {
    fetchBusinessSegments();
  }, []);

  useEffect(() => {
    fetchBusinessVerticals(selectedSegment);
    fetchSfAreas();
  }, [selectedSegment]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredData]);

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return (
        <span className="sort-icons">
          <ArrowDropUpIcon style={{ opacity: 0.3 }} />
          <ArrowDropDownIcon style={{ opacity: 0.3 }} />
        </span>
      );
    }
    return sortConfig.direction === 'ascending'
      ? <ArrowDropUpIcon />
      : <ArrowDropDownIcon />;
  };

  const formattedFromDateForAPI = formatDateForAPI(fromDate);
  const formattedToDateForAPI = formatDateForAPI(toDate);
  const verticalParam = selectedVertical || "ALL";
  const API_URL = `${local_signage}/api/v1/gtordermovementreport?SegmentCode=${selectedSegment}&VerticalCode=${verticalParam}&AreaId=${selectedSFAreaId}&FromDate=${formattedFromDateForAPI}&ToDate=${formattedToDateForAPI}`;

  const fetchLedgerData = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const response = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();

      const flattenedData = [];
      data.GTOrderMovement.forEach(order => {
        const itemMap = new Map();

        // Calculate Sale totals from saleitem array
        let saleTotalWeight = 0;
        if (order.saleitem && order.saleitem.length > 0) {
          order.saleitem.forEach(item => {
            saleTotalWeight += item.ItemWeight || 0;
          });
        }

        // Calculate SR totals from sritem array
        let srTotalQty = 0;
        let srTotalAmount = 0;
        let srTotalWeight = 0;
        let srPickUpDateTime = null;
        let srApproveDateTime = null;
        let srAcceptDateTime = null;

        if (order.sritem && order.sritem.length > 0) {
          order.sritem.forEach(srItem => {
            srTotalQty += srItem.qty || 0;
            srTotalAmount += srItem.SRAmount || 0;
            srTotalWeight += srItem.ItemWeight || 0;

            // Get the first non-empty datetime for SR fields
            if (!srPickUpDateTime && srItem.SRPickUpDateTime && srItem.SRPickUpDateTime !== "1753-01-01T00:00:00") {
              srPickUpDateTime = srItem.SRPickUpDateTime;
            }
            if (!srApproveDateTime && srItem.SRApproveDateTime && srItem.SRApproveDateTime !== "1753-01-01T00:00:00") {
              srApproveDateTime = srItem.SRApproveDateTime;
            }
            if (!srAcceptDateTime && srItem.SRAcceptDateTime && srItem.SRAcceptDateTime !== "1753-01-01T00:00:00") {
              srAcceptDateTime = srItem.SRAcceptDateTime;
            }
          });
        }

        // Add calculated totals to order
        order.TotalSaleWeight = saleTotalWeight;
        order.SRTotalQty = srTotalQty;
        order.SRTotalAmount = srTotalAmount;
        order.SRTotalWeight = srTotalWeight;

        // Use SR datetime from sritem if not available in order header
        if (!order.SRPickUpDateTime || order.SRPickUpDateTime === "1753-01-01T00:00:00") {
          order.SRPickUpDateTime = srPickUpDateTime || "1753-01-01T00:00:00";
        }
        if (!order.SRApproveDateTime || order.SRApproveDateTime === "1753-01-01T00:00:00") {
          order.SRApproveDateTime = srApproveDateTime || "1753-01-01T00:00:00";
        }
        if (!order.SRAcceptDateTime || order.SRAcceptDateTime === "1753-01-01T00:00:00") {
          order.SRAcceptDateTime = srAcceptDateTime || "1753-01-01T00:00:00";
        }

        if (order.saleitem && order.saleitem.length > 0) {
          order.saleitem.forEach(item => {
            const key = `${order.SaleId}_${item.BatchNumber}`;
            itemMap.set(key, {
              ...order,
              City: order.AreaName || "-",
              ItemID: item.ItemID,
              ItemName: item.ItemName,
              BatchNumber: item.BatchNumber,
              ItemQty: item.qty,
              ItemWeight: item.ItemWeight,
              ItemNos: item.ItemNos,
              ItemTotalAmount: item.TotalAmount,
              DeliveryCharge: item.DeliveryCharge,
              SRItemQty: 0,
              SRItemWeight: 0,
              SRItemAmount: 0
            });
          });
        }

        if (order.sritem && order.sritem.length > 0) {
          order.sritem.forEach(srItem => {
            const key = `${order.SaleId}_${srItem.BatchNumber}`;
            if (itemMap.has(key)) {
              const existing = itemMap.get(key);
              existing.SRItemQty = srItem.qty;
              existing.SRItemWeight = srItem.ItemWeight;
              existing.SRItemAmount = srItem.SRAmount;
            } else {
              itemMap.set(key, {
                ...order,
                City: order.AreaName || "-",
                ItemID: srItem.ItemID,
                ItemName: srItem.itemName,
                BatchNumber: srItem.BatchNumber,
                ItemQty: 0,
                ItemWeight: 0,
                ItemNos: 0,
                ItemTotalAmount: 0,
                DeliveryCharge: 0,
                SRItemQty: srItem.qty,
                SRItemWeight: srItem.ItemWeight,
                SRItemAmount: srItem.SRAmount
              });
            }
          });
        }

        itemMap.forEach(item => {
          flattenedData.push(item);
        });

        if ((!order.saleitem || order.saleitem.length === 0) && (!order.sritem || order.sritem.length === 0)) {
          flattenedData.push(order);
        }
      });

      setLedgerData(flattenedData);

      const summaryMap = new Map();
      flattenedData.forEach(item => {
        const key = item.SaleId;
        if (!summaryMap.has(key)) {
          summaryMap.set(key, {
            SaleId: item.SaleId,
            CustomerCode: item.CustomerCode,
            CustomerName: item.CustomerName,
            City: item.City,
            CreditLimit: item.CreditLimit,
            CreditDays: item.CreditDays,
            billingDateTime: item.billingDateTime,
            TotalQty: item.TotalQty,
            TotalSaleWeight: item.TotalSaleWeight,
            TotalAmount: item.TotalAmount,
            SRTotalQty: item.SRTotalQty,
            SRTotalWeight: item.SRTotalWeight,
            SRTotalAmount: item.SRTotalAmount,
            BillReceipt: item.BillReceipt,
            DeliveryDateTime: item.DeliveryDateTime,
            DeliveryApproveDateTime: item.DeliveryApproveDateTime,
            SRPickUpDateTime: item.SRPickUpDateTime,
            SRApproveDateTime: item.SRApproveDateTime,
            SRAcceptDateTime: item.SRAcceptDateTime,
            PromoCodes: item.PromoCodes,
            items: []
          });
        }
        summaryMap.get(key).items.push(item);
      });

      const summary = Array.from(summaryMap.values());
      setSummaryData(summary);
      setFilteredData(summary);
      setCurrentPage(1);
    } catch (error) {
      setError("Failed to fetch ledger data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = summaryData.filter((item) =>
      (item.CustomerName?.toLowerCase() || "").includes(query) ||
      (item.SaleId?.toLowerCase() || "").includes(query) ||
      (item.CustomerCode?.toLowerCase() || "").includes(query)
    );

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const toggleRow = (saleId) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(saleId)) {
      newExpanded.delete(saleId);
    } else {
      newExpanded.add(saleId);
    }
    setExpandedRows(newExpanded);
  };

  const exportToCSV = () => {
    const csvRows = [];

    const headers = [
      "Sr No",
      "Customer Code",
      "Customer Name",
      "City",
      "Item Name",
      "Batch Number",
      "Bill No",
      "Promo Code",
      "Credit Limit",
      "Credit Days",
      "Bill Date",
      "Bill Time",
      "Sale Qty",
      "Sale Wt. (KG)",
      "Sale Amount",
      "Sale Return Qty",
      "Sale Return Wt. (KG)",
      "Sale Return Amount",
      "Amt Receipt",
      "Balance",
      "Bill Cleared",
      "Delivery Date",
      "Delivery Time",
      "Delivery Confirm Date",
      "Delivery Confirm Time",
      "SR Pickup Date",
      "SR Pickup Time",
      "SR Approve Date",
      "SR Approve Time",
      "SR POS Accepted Date",
      "SR POS Accepted Time",
    ];
    csvRows.push(headers.join(","));

    ledgerData.forEach((item, index) => {
      const balance = (item.TotalAmount || 0) - (item.SRTotalAmount || 0) - (item.BillReceipt || 0);

      const row = [
        index + 1,
        item.CustomerCode || "-",
        item.CustomerName || "-",
        item.City || "-",
        item.ItemName || "-",
        item.BatchNumber || "-",
        item.SaleId || "-",
        item.PromoCodes || "-",
        `${item.CreditLimit?.toFixed(2) || "0.00"}`,
        item.CreditDays || "0",
        formatDateTime(item.billingDateTime, "date"),
        formatDateTime(item.billingDateTime, "time"),
        item.ItemQty || "0",
        `${item.ItemWeight || "0"}`,
        `${item.ItemTotalAmount?.toFixed(2) || "0.00"}`,
        item.SRItemQty || "0",
        `${item.SRItemWeight || "0"}`,
        `${item.SRItemAmount?.toFixed(2) || "0.00"}`,
        `${item.BillReceipt?.toFixed(2) || "0.00"}`,
        `${balance.toFixed(2)}`,
        balance <= 0 ? "Y" : "N",
        formatDateTime(item.DeliveryDateTime, "date"),
        formatDateTime(item.DeliveryDateTime, "time"),
        formatDateTime(item.DeliveryApproveDateTime, "date"),
        formatDateTime(item.DeliveryApproveDateTime, "time"),
        formatDateTime(item.SRPickUpDateTime, "date"),
        formatDateTime(item.SRPickUpDateTime, "time"),
        formatDateTime(item.SRApproveDateTime, "date"),
        formatDateTime(item.SRApproveDateTime, "time"),
        formatDateTime(item.SRAcceptDateTime, "date"),
        formatDateTime(item.SRAcceptDateTime, "time"),
      ];

      csvRows.push(row.join(","));
    });

    const csvContent = "\uFEFF" + csvRows.join("\n");
    const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "gt_order_movement_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSegmentChange = (event) => {
    setSelectedSegment(event.target.value);
  };

  const handleVerticalChange = (event) => {
    setSelectedVertical(event.target.value);
  };

  const handleSfAreaChange = (event) => {
    setSelectedSFAreaId(event.target.value);
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const processedFilteredData = [...filteredData].map(item => ({
    ...item,
    balance: (item.TotalAmount || 0) - (item.SRTotalAmount || 0) - (item.BillReceipt || 0)
  })).sort((a, b) => {
    if (sortConfig.key) {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
      }

      if (sortConfig.key.includes('DateTime')) {
        aValue = aValue ? new Date(aValue) : new Date(0);
        bValue = bValue ? new Date(bValue) : new Date(0);
        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
      }

      aValue = (aValue || '').toString().toLowerCase();
      bValue = (bValue || '').toString().toLowerCase();

      if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  const currentRecords = processedFilteredData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(processedFilteredData.length / recordsPerPage);

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const pageNumbers = [];

    if (totalPages <= maxPageNumbersToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 2) {
        endPage = Math.min(4, totalPages - 1);
      }

      if (currentPage >= totalPages - 1) {
        startPage = Math.max(2, totalPages - 3);
      }

      if (startPage > 2) {
        pageNumbers.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages - 1) {
        pageNumbers.push('...');
      }

      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const LoadingOverlay = () => (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255,0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <CircularProgress size={60} />
    </div>
  );

  const isGTMTSegment = (code) => code === "MODERN";

  return (
    <>
      <Header />
      {loading && <LoadingOverlay />}
      <div className="gt-customer-container">
        <div className="gt-customer-controls-wrapper">
          <div className="gt-customer-date-input-container">
            <select
              className="gt-customer-dropdown"
              value={selectedSegment}
              onChange={handleSegmentChange}
              disabled={isGTMTSegment(selectedSegment)}
            >
              {businessSegments.map((segment) => (
                <option
                  key={segment.businessSegmentCode}
                  value={segment.businessSegmentCode}
                >
                  {segment.businessSegmentName}
                </option>
              ))}
            </select>

            <select
              className="gt-customer-dropdown"
              value={selectedVertical}
              onChange={handleVerticalChange}
              disabled={!selectedSegment || selectedSegment === "ALL"}
            >
              {businessVerticals.map((vertical) => (
                <option key={vertical.businessVerticalCode} value={vertical.businessVerticalCode}>
                  {vertical.businessVerticalName} {vertical.businessVerticalCode !== "ALL" ? `(${vertical.businessVerticalCode})` : ""}
                </option>
              ))}
            </select>

            <select
              className="gt-customer-dropdown"
              value={selectedSFAreaId}
              onChange={handleSfAreaChange}
            >
              {sfAreas.map((area) => (
                <option key={area.SFAreaId} value={area.SFAreaId}>
                  {area.SFAreaName} {area.SFAreaId !== "ALL" ? `(${area.SFAreaId})` : ""}
                </option>
              ))}
            </select>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={fromDate}
                onChange={handleFromDateChange}
                format="DD-MM-YYYY"
                sx={datePickerStyle}
                slotProps={{
                  textField: {
                    size: "small",
                    variant: "outlined"
                  }
                }}
              />

              <DatePicker
                value={toDate}
                onChange={handleToDateChange}
                format="DD-MM-YYYY"
                sx={datePickerStyle}
                slotProps={{
                  textField: {
                    size: "small",
                    variant: "outlined"
                  }
                }}
              />
            </LocalizationProvider>

            <button
              onClick={fetchLedgerData}
              className="gt-customer-submit-button"
              disabled={loading}
            >
              Submit
            </button>
            <button
              onClick={exportToCSV}
              className="gt-customer-export-button"
              disabled={loading || ledgerData.length === 0}
            >
              Export to CSV
            </button>

            <div className="gt-customer-search-pagination-container">
            <div className="gt-customer-search-container">
              <input
                type="text"
                placeholder="Search by Customer Name or Bill No"
                value={searchQuery}
                onChange={handleSearch}
                className="gt-customer-search-input"
              />


            {filteredData.length > recordsPerPage && (
              <div className="pagination-container">
                <button
                  onClick={() => paginate(1)}
                  disabled={currentPage === 1}
                  className="pagination-button"
                >
                  First
                </button>
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="pagination-button"
                >
                  Prev
                </button>

                {pageNumbers.map((number, index) => (
                  number === '...' ?
                  <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span> :
                  <button
                    key={number}
                    onClick={() => paginate(number)}
                    className={`pagination-button ${currentPage === number ? 'pagination-active' : ''}`}
                  >
                    {number}
                  </button>
                ))}

                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="pagination-button"
                >
                  Next
                </button>
                <button
                  onClick={() => paginate(totalPages)}
                  disabled={currentPage === totalPages}
                  className="pagination-button"
                >
                  Last
                </button>

                <span className="pagination-info">
                  Page {currentPage} of {totalPages}
                </span>
              </div>
            )}
             </div>
          </div>
          </div>
        </div>

        <div className="gt-customer-table-container">
          <div className="gt-customer-table-scroll">
            <table className="gt-customer-table">
              <thead>
                <tr>
                  <th style={{ width: '40px' }}></th>
                  <th onClick={() => handleSort('index')}>
                    S No. <SortIcon columnKey="index" />
                  </th>
                  <th onClick={() => handleSort('CustomerCode')}>
                    Customer Code <SortIcon columnKey="CustomerCode" />
                  </th>
                  <th onClick={() => handleSort('CustomerName')}>
                    Customer Name <SortIcon columnKey="CustomerName" />
                  </th>
                  <th>City</th>
                  <th onClick={() => handleSort('SaleId')}>
                    Bill No <SortIcon columnKey="SaleId" />
                  </th>
                  <th>Promo Code</th>
                  <th>Credit Limit</th>
                  <th>Credit Days</th>
                  <th>Bill Date</th>
                  <th>Bill Time</th>
                  <th>Total Sale Qty</th>
                  <th>Total Sale Wt. (KG)</th>
                  <th>Total Sale Amount</th>
                  <th>Total Sale Return Qty</th>
                  <th>Total Sale Return Wt. (KG)</th>
                  <th>Total Sale Return Amount</th>
                  <th>Amt Receipt</th>
                  <th>Balance</th>
                  <th>Bill Cleared</th>
                  <th>Delivery Date</th>
                  <th>Delivery Time</th>
                  <th>Delivery Confirm Date</th>
                  <th>Delivery Confirm Time</th>
                  <th>SR Pickup Date</th>
                  <th>SR Pickup Time</th>
                  <th>SR Approve Date</th>
                  <th>SR Approve Time</th>
                  <th>SR POS Accepted Date</th>
                  <th>SR POS Accepted Time</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="30" className="gt-customer-loading-container">
                      <CircularProgress />
                    </td>
                  </tr>
                ) : currentRecords.length > 0 ? (
                  currentRecords.map((item, index) => {
                    const actualIndex = indexOfFirstRecord + index;
                    const billingDate = formatDateTime(item.billingDateTime, "date");
                    const billingTime = formatDateTime(item.billingDateTime, "time");
                    const deliveryDate = formatDateTime(item.DeliveryDateTime, "date");
                    const deliveryTime = formatDateTime(item.DeliveryDateTime, "time");
                    const deliveryApproveDate = formatDateTime(item.DeliveryApproveDateTime, "date");
                    const deliveryApproveTime = formatDateTime(item.DeliveryApproveDateTime, "time");
                    const srPickUpDate = formatDateTime(item.SRPickUpDateTime, "date");
                    const srPickUpTime = formatDateTime(item.SRPickUpDateTime, "time");
                    const srApproveDate = formatDateTime(item.SRApproveDateTime, "date");
                    const srApproveTime = formatDateTime(item.SRApproveDateTime, "time");
                    const srAcceptedDate = formatDateTime(item.SRAcceptDateTime, "date");
                    const srAcceptedTime = formatDateTime(item.SRAcceptDateTime, "time");
                    const cleared = item.balance <= 0 ? "Y" : "N";
                    const isExpanded = expandedRows.has(item.SaleId);

                    return (
                      <>
                        <tr key={actualIndex} className="summary-row">
                          <td onClick={() => toggleRow(item.SaleId)} className="expand-cell">
                            <div className="expand-icon">
                              {isExpanded ? '▼' : '▶'}
                            </div>
                          </td>
                          <td className="serial-cell">{actualIndex + 1}</td>
                          <td className="code-cell">{item.CustomerCode || "-"}</td>
                          <td className="customer-name-cell">{item.CustomerName || "-"}</td>
                          <td className="city-cell">{item.City || "-"}</td>
                          <td className="bill-cell">{item.SaleId || "-"}</td>
                          <td className="promo-cell">{item.PromoCodes || "-"}</td>
                          <td className="amount-cell">₹{item.CreditLimit?.toFixed(2) || "0.00"}</td>
                          <td className="days-cell">{item.CreditDays || "0"}</td>
                          <td className="date-cell">{billingDate}</td>
                          <td className="time-cell">{billingTime}</td>
                          <td className="qty-cell sale-qty">{item.TotalQty || "0"}</td>
                          <td className="weight-cell sale-weight">{item.TotalSaleWeight?.toFixed(2) || "0.00"} KG</td>
                          <td className="amount-cell sale-amount">₹{item.TotalAmount?.toFixed(2) || "0.00"}</td>
                          <td className="qty-cell return-qty">{item.SRTotalQty || "0"}</td>
                          <td className="weight-cell return-weight">{item.SRTotalWeight?.toFixed(2) || "0.00"} KG</td>
                          <td className="amount-cell return-amount">₹{item.SRTotalAmount?.toFixed(2) || "0.00"}</td>
                          <td className="amount-cell receipt-amount">₹{item.BillReceipt?.toFixed(2) || "0.00"}</td>
                          <td className={`amount-cell balance-cell ${item.balance > 0 ? 'balance-pending' : 'balance-cleared'}`}>
                            ₹{item.balance.toFixed(2)}
                          </td>
                          <td className={`cleared-cell ${cleared === 'Y' ? 'cleared-yes' : 'cleared-no'}`}>{cleared}</td>
                          <td className="date-cell">{deliveryDate}</td>
                          <td className="time-cell">{deliveryTime}</td>
                          <td className="date-cell">{deliveryApproveDate}</td>
                          <td className="time-cell">{deliveryApproveTime}</td>
                          <td className="date-cell">{srPickUpDate}</td>
                          <td className="time-cell">{srPickUpTime}</td>
                          <td className="date-cell">{srApproveDate}</td>
                          <td className="time-cell">{srApproveTime}</td>
                          <td className="date-cell">{srAcceptedDate}</td>
                          <td className="time-cell">{srAcceptedTime}</td>
                        </tr>
                        {isExpanded && item.items && item.items.map((detailItem, detailIndex) => {
                          const hasReturn = detailItem.SRItemQty > 0 || detailItem.SRItemAmount > 0;
                          return (
                            <tr key={`${actualIndex}-${detailIndex}`} className={`detail-row ${hasReturn ? 'has-return' : ''}`}>
                              <td className="detail-expand"></td>
                              <td className="detail-serial">{detailIndex + 1}</td>
                              <td colSpan="3" className="item-name-detail">
                                <div className="item-detail-container">
                                  <span className="item-icon">📦</span>
                                  <span className="item-name">{detailItem.ItemName || "-"}</span>
                                </div>
                              </td>
                              <td className="batch-detail">
                                <span className="batch-badge">{detailItem.BatchNumber || "-"}</span>
                              </td>
                              <td colSpan="5"></td>
                              <td className="detail-qty sale-detail">{detailItem.ItemQty || "0"}</td>
                              <td className="detail-weight sale-detail">{detailItem.ItemWeight?.toFixed(2) || "0.00"} KG</td>
                              <td className="detail-amount sale-detail">₹{detailItem.ItemTotalAmount?.toFixed(2) || "0.00"}</td>
                              <td className="detail-qty return-detail">{detailItem.SRItemQty || "0"}</td>
                              <td className="detail-weight return-detail">{detailItem.SRItemWeight?.toFixed(2) || "0.00"} KG</td>
                              <td className="detail-amount return-detail">₹{detailItem.SRItemAmount?.toFixed(2) || "0.00"}</td>
                              <td colSpan="13"></td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="30" className="gt-customer-no-data">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <style>{`
        /* Pagination Styles */
        .pagination-container {
          margin: 15px 0;
          margin-left: 30px;
        }
        .pagination-button {
          padding: 5px 10px;
          margin: 0 2px;
          border: 1px solid #ccc;
          background: #f5f5f5;
          cursor: pointer;
          color: black;
        }
        .pagination-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .pagination-active {
          background: #004D00;
          color: white;
          border-color: #004D00;
        }
        .data-count {
          margin-left: 15px;
          font-weight: bold;
        }
        .loader-container {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 20px 0;
        }
        .date-picker-container {
          min-width: 180px;
          margin: 0 5px;
        }
        .customer-date-input-container {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 20px;
        }

        /* Enhanced Summary Row Styles */
        .summary-row {
          background: linear-gradient(to right, #ffffff 0%, #f8f9fa 100%);
          transition: all 0.3s ease;
          border-left: 4px solid transparent;
        }

        .summary-row:hover {
          background: linear-gradient(to right, #e8f5e9 0%, #c8e6c9 100%);
          border-left: 4px solid #004D00;
          box-shadow: 0 2px 8px rgba(0, 77, 0, 0.15);
          transform: translateX(2px);
        }

        /* Expand Icon Cell */
        .expand-cell {
          cursor: pointer;
          text-align: center;
          background: #e8f5e9;
          border-right: 2px solid #004D00;
        }

        .expand-icon {
          display: inline-block;
          width: 28px;
          height: 28px;
          line-height: 28px;
          border-radius: 50%;
          background: #004D00;
          color: white;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .expand-icon:hover {
          background: #006400;
          transform: scale(1.15);
          box-shadow: 0 2px 8px rgba(0, 77, 0, 0.4);
        }

        /* Cell Type Styles */
        .serial-cell {
          font-weight: 600;
          color: #424242;
          text-align: center;
        }

        .code-cell {
          font-family: 'Courier New', monospace;
          font-size: 12px;
          color: #004D00;
          font-weight: 600;
        }

        .customer-name-cell {
          font-weight: 600;
          color: #004D00;
          max-width: 200px;
        }

        .city-cell {
          color: #2e7d32;
          font-weight: 500;
        }

        .bill-cell {
          font-family: 'Courier New', monospace;
          font-weight: 700;
          color: #d32f2f;
          background: #ffebee;
          text-align: center;
        }

        .promo-cell {
          font-style: italic;
          color: #f57c00;
        }

        .amount-cell {
          text-align: right;
          font-weight: 600;
          font-family: 'Courier New', monospace;
        }

        .days-cell {
          text-align: center;
          font-weight: 600;
          color: #6a1b9a;
        }

        .date-cell {
          color: #616161;
          font-size: 13px;
        }

        .time-cell {
          color: #757575;
          font-size: 12px;
          font-style: italic;
        }

        /* Quantity and Amount Color Coding */
        .qty-cell {
          text-align: center;
          font-weight: 700;
        }

        .sale-qty {
          color: #2e7d32;
          background: #e8f5e9;
        }

        .sale-amount {
          color: #2e7d32;
          background: #e8f5e9;
        }

        .return-qty {
          color: #c62828;
          background: #ffebee;
        }

        .return-amount {
          color: #c62828;
          background: #ffebee;
        }

        .receipt-amount {
          color: #004D00;
          background: #e8f5e9;
        }

        /* Balance Cell Styles */
        .balance-cell {
          font-weight: 700;
          font-size: 14px;
        }

        .balance-pending {
          color: #d32f2f;
          background: #ffcdd2;
        }

        .balance-cleared {
          color: #388e3c;
          background: #c8e6c9;
        }

        /* Cleared Status */
        .cleared-cell {
          text-align: center;
          font-weight: 900;
          font-size: 14px;
        }

        .cleared-yes {
          color: #388e3c;
          background: #c8e6c9;
        }

        .cleared-no {
          color: #d32f2f;
          background: #ffcdd2;
        }

        /* Detail Row Styles */
        .detail-row {
          background: #f5f5f5;
          border-left: 4px solid #81c784;
          animation: slideIn 0.3s ease-out;
        }

        .detail-row.has-return {
          background: linear-gradient(to right, #fff3e0 0%, #ffe0b2 100%);
          border-left: 4px solid #ff9800;
        }

        .detail-row:hover {
          background: #e8f5e9;
          transform: translateX(4px);
          transition: all 0.2s ease;
        }

        .detail-row.has-return:hover {
          background: linear-gradient(to right, #ffe0b2 0%, #ffcc80 100%);
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Detail Cell Styles */
        .detail-expand {
          background: #e8f5e9;
        }

        .detail-serial {
          text-align: center;
          font-weight: 600;
          color: #004D00;
          font-size: 12px;
        }

        .item-name-detail {
          padding-left: 30px !important;
        }

        .item-detail-container {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .item-icon {
          font-size: 18px;
        }

        .item-name {
          font-weight: 700;
          color: #004D00;
          font-size: 14px;
        }

        .batch-detail {
          text-align: center;
        }

        .batch-badge {
          display: inline-block;
          padding: 4px 12px;
          background: linear-gradient(135deg, #004D00 0%, #006400 100%);
          color: white;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.5px;
          box-shadow: 0 2px 4px rgba(0, 77, 0, 0.3);
        }

        .detail-qty {
          text-align: center;
          font-weight: 700;
          font-size: 13px;
        }

        .detail-amount {
          text-align: right;
          font-weight: 700;
          font-family: 'Courier New', monospace;
          font-size: 13px;
        }

        .sale-detail {
          color: #2e7d32;
        }

        .return-detail {
          color: #c62828;
        }

        /* Table Header Enhancements */
        .gt-customer-table thead th {
          background: linear-gradient(to bottom, #004D00 0%, #003300 100%);
          color: white;
          font-weight: 700;
          text-transform: uppercase;
          font-size: 11px;
          letter-spacing: 0.5px;
          border-right: 1px solid rgba(255, 255, 255, 0.1);
          padding: 12px 8px;
          position: sticky;
          top: 0;
          z-index: 10;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .gt-customer-table thead th:hover {
          background: linear-gradient(to bottom, #006400 0%, #004D00 100%);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .date-picker-container {
            width: 100%;
            margin: 5px 0;
          }
          .customer-date-input-container {
            flex-direction: column;
            align-items: stretch;
          }
          .item-name {
            font-size: 12px;
          }
          .batch-badge {
            font-size: 10px;
            padding: 3px 8px;
          }
        }
      `}</style>
    </>
  );
};

export default GTOrderMove;
